
import { defineComponent, onBeforeMount, reactive } from 'vue'
import moment from 'moment'

// components
import PageTitle from '@/common/components/UI/PageTitle/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'
import TheTable from '@/common/components/UI/TheTable/index.vue'
import TableScrollWrapper from '@/common/components/UI/TableScrollWrapper/index.vue'
import FailedFetch from '@/common/components/UI/FailedFetch/index.vue'
import TheInput from '@/common/components/UI/TheInput/index.vue'
import TheSelect from '@/common/components/UI/TheSelect/index.vue'

// types
import { CityT } from '@/core/types/cities.types'
import { GetWarehousesParams, Warehouse } from '@/new-services/types/location'

// realisations
import { cities } from '@/core/realisations/cities.realisation'
import locationAPI from '@/new-services/location.service'

// classes
import { DataState } from '@/core/classes/DataState.class'

// constants
import { WarehousesColumns } from '@/core/constants/columns/Warehouses.columns'
import { useFile } from '@/common/composable/useFile'

export default defineComponent({
    components: {
        PageTitle,
        TheButton,
        FailedFetch,
        TheInput,
        TheTable,
        TableScrollWrapper,
        TheSelect,
    },
    setup() {
        const { saveFile } = useFile()

        const state = reactive(new DataState<Warehouse>({}))
        const data_state = reactive(new DataState<CityT>({}))

        const filters_state = reactive({
            title: null as string | null,
            cityIds: [] as number[],
            //
            limit: 50,
        })

        const excel_state = reactive({
            is_loading: false,
        })

        const loadWarehouses = async (page: number) => {
            state.pagination.current_page = page

            try {
                state.is_loading = true

                const params = {
                    page,
                    title: filters_state.title,
                    cityIds: filters_state.cityIds,
                }

                const response = await locationAPI.getWarehouses(params as GetWarehousesParams)
                state.list = response.data.data

                state.pagination.total_pages = response.data.meta.last_page
                state.pagination.total_items = response.data.meta.total

                state.is_failed = false
                state.failure.error_state.is_cancel = false
            } catch (error) {
                state.failure.catchError(error)

                if (!state.failure.error_state.is_cancel) {
                    state.is_failed = true
                }
            } finally {
                if (!state.failure.error_state.is_cancel) {
                    state.is_loading = false
                }
            }
        }

        const onLimitChange = (limit: number) => {
            filters_state.limit = limit
            loadWarehouses(state.pagination.current_page)
        }

        const searchCity = async () => {
            await loadWarehouses(1)
        }

        const resetFilter = async () => {
            filters_state.title = null
            filters_state.cityIds = []

            await loadWarehouses(1)
        }

        const loadCities = async (page: number, search?: string) => {
            data_state.pagination.current_page = page

            try {
                data_state.is_loading = true

                const data = await cities.getAllList(page, search, 9999)
                data_state.list = data.data

                data_state.pagination.total_pages = data.meta.last_page

                data_state.is_failed = false
                data_state.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.failure.catchError(error)

                if (!data_state.failure.error_state.is_cancel) {
                    data_state.is_failed = true
                }
            } finally {
                if (!data_state.failure.error_state.is_cancel) {
                    data_state.is_loading = false
                }
            }
        }

        const exportExcel = async () => {
            try {
                excel_state.is_loading = true

                const params = {
                    title: filters_state.title,
                    cityIds: filters_state.cityIds,
                }

                const response = await locationAPI.exportWarehousesExcel(params)
                saveFile(response.data, 'Поставщики')
            } catch (e) {
                console.log(e)
            } finally {
                excel_state.is_loading = false
            }
        }

        const formatDate = (dateStr: string) => {
            if (!dateStr) return '-'

            const dateFirst = dateStr.split(' ')[0]
            return dateFirst.split('-').reverse().join('.')
        }

        onBeforeMount(() => {
            loadWarehouses(1)
            loadCities(1)
        })

        return {
            state,
            data_state,
            filters_state,
            excel_state,
            loadWarehouses,
            searchCity,
            resetFilter,
            onLimitChange,
            moment,
            loadCities,
            exportExcel,
            formatDate,
            //
            WarehousesColumns,
        }
    },
})
